/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodCategory } from './PaymentMethodCategory';
import {
    PaymentMethodCategoryFromJSON,
    PaymentMethodCategoryFromJSONTyped,
    PaymentMethodCategoryToJSON,
    PaymentMethodCategoryToJSONTyped,
} from './PaymentMethodCategory';
import type { PaymentMethodConfiguration } from './PaymentMethodConfiguration';
import {
    PaymentMethodConfigurationFromJSON,
    PaymentMethodConfigurationFromJSONTyped,
    PaymentMethodConfigurationToJSON,
    PaymentMethodConfigurationToJSONTyped,
} from './PaymentMethodConfiguration';
import type { PayoutSource } from './PayoutSource';
import {
    PayoutSourceFromJSON,
    PayoutSourceFromJSONTyped,
    PayoutSourceToJSON,
    PayoutSourceToJSONTyped,
} from './PayoutSource';

/**
 * 
 * @export
 * @interface PaymentMethodDetailsDto
 */
export interface PaymentMethodDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    externalId: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodDetailsDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentMethodCategory}
     * @memberof PaymentMethodDetailsDto
     */
    paymentMethodCategory: PaymentMethodCategory;
    /**
     * 
     * @type {PayoutSource}
     * @memberof PaymentMethodDetailsDto
     */
    payoutSource: PayoutSource;
    /**
     * 
     * @type {PaymentMethodConfiguration}
     * @memberof PaymentMethodDetailsDto
     */
    _configuration: PaymentMethodConfiguration;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    createdByUserEmail: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailsDto
     */
    updatedByUserEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodDetailsDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodDetailsDto
     */
    updated: Date;
}



/**
 * Check if a given object implements the PaymentMethodDetailsDto interface.
 */
export function instanceOfPaymentMethodDetailsDto(value: object): value is PaymentMethodDetailsDto {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentMethodCategory' in value) || value['paymentMethodCategory'] === undefined) return false;
    if (!('payoutSource' in value) || value['payoutSource'] === undefined) return false;
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    if (!('createdByUserEmail' in value) || value['createdByUserEmail'] === undefined) return false;
    if (!('updatedByUserEmail' in value) || value['updatedByUserEmail'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function PaymentMethodDetailsDtoFromJSON(json: any): PaymentMethodDetailsDto {
    return PaymentMethodDetailsDtoFromJSONTyped(json, false);
}

export function PaymentMethodDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryFromJSON(json['paymentMethodCategory']),
        'payoutSource': PayoutSourceFromJSON(json['payoutSource']),
        '_configuration': PaymentMethodConfigurationFromJSON(json['configuration']),
        'createdByUserEmail': json['createdByUserEmail'],
        'updatedByUserEmail': json['updatedByUserEmail'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function PaymentMethodDetailsDtoToJSON(json: any): PaymentMethodDetailsDto {
    return PaymentMethodDetailsDtoToJSONTyped(json, false);
}

export function PaymentMethodDetailsDtoToJSONTyped(value?: PaymentMethodDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryToJSON(value['paymentMethodCategory']),
        'payoutSource': PayoutSourceToJSON(value['payoutSource']),
        'configuration': PaymentMethodConfigurationToJSON(value['_configuration']),
        'createdByUserEmail': value['createdByUserEmail'],
        'updatedByUserEmail': value['updatedByUserEmail'],
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
    };
}

